import Link from 'components/Atoms/Link';
import { footerLinks } from 'helpers/constants';
import moment from 'moment';
import React from 'react'

const Footer = () => {
  const currentYear = moment().year();

  return (
    <div className="flex flex-col gap-y-1 items-center justify-center py-3">
      <div className="flex gap-3 flex-wrap justify-center">
        {footerLinks.map((footerLink: any, i: number) => {
          return (<>
            <Link className='text-black text-sm' key={i} href={footerLink.link} target='_blank'>
              {footerLink.label}
            </Link>
            {i < footerLinks.length - 1 && <div className='my-1 border-r-[.5px] border-solid border-gray-500'></div>}
          </>);
        })}
      </div>
      <div className='text-black text-sm'>&copy; {`${currentYear} The Parts House - All Rights Reserved.`}</div>
    </div>
  )
}

export default Footer;
